import { render, staticRenderFns } from "./DropdownWrap.vue?vue&type=template&id=8df561b0&scoped=true&"
import script from "./DropdownWrap.vue?vue&type=script&lang=js&"
export * from "./DropdownWrap.vue?vue&type=script&lang=js&"
import style0 from "./DropdownWrap.vue?vue&type=style&index=0&id=8df561b0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df561b0",
  null
  
)

export default component.exports